import React, { Component, Fragment } from 'react';

import './PageHomeContent.css';

class PageHomeContent extends Component {

    constructor(props) {
        super(props);
        this.autocompleteInit = this.props.autocompleteInit;
    }

    componentDidMount() {
        this.autocompleteInit();
    }

    getFormComponent() {
        return <Form
            onSubmit={ this.props.onSubmit }
            btnTxt={ this.props.btnTxt } />;
    }

    getLinkToBattery() {
        return null;
        //return <div className="slc-container slc-link-battery"><a className="slc-text-link" href="https://sunhub.it/batteria"><span>Ti interessa solo un Sistema di Accumulo?</span><span>Vai al configuratore Batterie!</span></a></div>;
    }

    render() {
        return (
            <Fragment>
                <div className="slc-page-row">
                    <div className="slc-container slc-infos">
                        <div className="slc-infos_title">{ this.props.title }</div>
                        <div className="slc-infos_infos" dangerouslySetInnerHTML={ { __html: this.props.infos } } />
                    </div>
                </div>
                <div className="slc-page-row">
                    { this.getFormComponent() }
                    { this.getLinkToBattery() }
                </div>
                <div className="slc-page-row">
                    <div className="slc-container slc-image-container">
                        <img className="slc-image" src={ this.props.imagePath } alt="" />
                    </div>
                </div>
            </Fragment>
        );
    }
    
};

const Form = (props) => {
    return (
        <div className="slc-container slc-form">
            <input type="text" className="slc-form-input slc-form-input-text user-address" id="user-address" placeholder="Inserisci l'indirizzo del tuo tetto"></input>
            <input type="text" className="slc-form-input slc-form-input-text user-email hide" id="user-email" placeholder="Inserisci la tua e-mail (facoltativo)"></input>
            <button className="slc-page-body__content__button btn-small" id="slc-btn-start" onClick={props.onSubmit}>{props.btnTxt}</button>
        </div>
    );
};

export default PageHomeContent;